import React from "react";
import Styles from "./EditModal.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import TextInput from "../../../../../commons/Inputs/TextInput/TextInput";
import { ReactComponent as Upload } from "../../../../../assets/images/UploadFile.svg";

const EditModal = ({
  open,
  handleClose,
  ledgerId,
  month,
  setMonth,
  injection,
  setInjection,
  drawal,
  setDrawal,
  fileValue,
  selectedFileData,
  handleFileChange,
  handleApplySubmit,
  applyLoading,
}) => {
  const truncateFileName = (fileName, maxLength = 20) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;

    const extension = fileName.split(".").pop();
    const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf("."));
    const truncatedName = nameWithoutExt.substring(
      0,
      maxLength - extension.length - 4
    );

    return `${truncatedName}...${extension}`;
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">Edit Ledger</div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.upMainCont}>
            <div className={Styles.btnsSection}>
              <div className={Styles.firstBtnSection}>
                <div className={Styles.monthSection}>
                  <div>Month *</div>
                  <div>
                    <input
                      type="month"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      max={new Date().toISOString().slice(0, 7)}
                      // onChange={(e) => setMonth(e.target.value)}
                      className={Styles.monthInput}
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        fontSize: "14px",
                        width: "186px",
                        height: "40px",
                        marginTop: "4px",
                      }}
                    />
                  </div>
                </div>
                <div className={Styles.monthSection}>
                  <div>Regional Energy Account *</div>
                  <div className={Styles.customFileUpload}>
                    <label
                      htmlFor="ledgerFileUpload"
                      className={Styles.uploadLabel}
                    >
                      {fileValue?.fileName ? (
                        <span
                          className={Styles.uploadedFileName}
                          title={fileValue.fileName}
                        >
                          File:{" "}
                          <strong>
                            {truncateFileName(fileValue.fileName)}
                          </strong>
                        </span>
                      ) : selectedFileData?.name ? (
                        <span
                          className={Styles.uploadedFileName}
                          title={selectedFileData.name}
                        >
                          Selected:{" "}
                          <strong>
                            {truncateFileName(selectedFileData.name)}
                          </strong>
                        </span>
                      ) : fileValue?.id ? (
                        <span className={Styles.uploadedFileName}>
                          Loading filename...
                        </span>
                      ) : (
                        <div className={Styles.uploadHeader}>
                          Upload Ledger PDF
                          <span>
                            <Upload
                              width="40px"
                              height="30px"
                              display="flex"
                              justifyContent="center"
                            />
                          </span>
                        </div>
                      )}
                    </label>
                    <input
                      type="file"
                      id="ledgerFileUpload"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e.target.files[0])}
                      style={{ display: "none" }}
                    />
                    {fileValue?.error && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "4px",
                          fontSize: "10px",
                        }}
                      >
                        {fileValue.error}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className={Styles.firstBtnSection}>
                <div className={Styles.monthSection}>
                  <div>Injection *</div>
                  <div>
                    <TextInput
                      example="Enter injection"
                      value={injection}
                      onChange={(val) => {
                        if (/^\d*$/.test(val)) {
                          setInjection(val);
                        }
                      }}
                      type="number"
                      min={0}
                    />
                  </div>
                </div>
                <div className={Styles.monthSection}>
                  <div>Drawal *</div>
                  <div>
                    <TextInput
                      example="Enter drawal"
                      value={drawal}
                      onChange={(val) => {
                        if (/^\d*$/.test(val)) {
                          setDrawal(val);
                        }
                      }}
                      type="number"
                      min={0}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={Styles.buttonSubmit}>
            <button
              onClick={handleApplySubmit}
              disabled={
                applyLoading ||
                (!fileValue?.id && !selectedFileData) ||
                !month ||
                injection === "" ||
                drawal === ""
              }
              style={{
                cursor:
                  applyLoading ||
                  (!fileValue?.id && !selectedFileData) ||
                  !month ||
                  injection === "" ||
                  drawal === ""
                    ? "not-allowed"
                    : "pointer",
              }}
              className={Styles.applyButton}
            >
              {applyLoading ? "Applying..." : "Apply"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditModal;
